module.exports = __webpack_public_path__ + "static/fonts/Mont-ExtraLightItalic.a53f5c0.eot";